import { computed } from 'vue';
import { useAuthenticated } from '@othercommerce/foundation';
import { Features } from '@shared/features';

export function useSettlementsPermissions() {
  const authenticated = useAuthenticated();

  const canRequestSettlements = computed(() => {
    if (!authenticated.value) {
      return false;
    }

    if (!authenticated.value.b2b) {
      return false;
    }

    if (Features.streamsoft.isEnabled) {
      if (!authenticated.value.erpId) {
        return false;
      }
    }

    return true;
  });

  return { canRequestSettlements };
}
